import DxButton from "devextreme-vue/button";
import DxCheckBox from "devextreme-vue/check-box";
import DxValidationGroup from "devextreme-vue/validation-group";
import DxValidator, { DxRequiredRule } from "devextreme-vue/validator";
import { DxTextBox, DxButton as DxTextBoxButton } from 'devextreme-vue/text-box';

import notify from 'devextreme/ui/notify';

import { authService } from '../../../services/auth.service';

export default {
  name: "change-password",
  data() {
    return {
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",

      divCurrentPasswordVisible: true,
      currentPasswordMode: 'password',
      currentPasswordButton: null,

      newPasswordMode: 'password',
      newPasswordButton: {
        icon: 'key',
        type: 'default',
        onClick: () => {
          this.newPasswordMode = this.newPasswordMode === 'text' ? 'password' : 'text';
        }
      },

      confirmPasswordMode: 'password',
      confirmPasswordButton: {
        icon: 'key',
        type: 'default',
        onClick: () => {
          this.confirmPasswordMode = this.confirmPasswordMode === 'text' ? 'password' : 'text';
        }
      },
    };
  },
  computed: {
    changePasswordRequiredMessage1() {
      return process.env.VUE_APP_BASE_MESSAGE_CHANGE_PASSWORD_REQUIRED_MESSAGE_1;
    },
    changePasswordRequiredMessage2() {
      return process.env.VUE_APP_BASE_MESSAGE_CHANGE_PASSWORD_REQUIRED_MESSAGE_2;
    },
    changePasswordRequiredMessage3() {
      return process.env.VUE_APP_BASE_MESSAGE_CHANGE_PASSWORD_REQUIRED_MESSAGE_3;
    },
    changePasswordRequiredMessage4() {
      return process.env.VUE_APP_BASE_MESSAGE_CHANGE_PASSWORD_REQUIRED_MESSAGE_4;
    },
    changePasswordRequiredMessage5() {
      return process.env.VUE_APP_BASE_MESSAGE_CHANGE_PASSWORD_REQUIRED_MESSAGE_5;
    },
    changePasswordRequiredMessage6() {
      return process.env.VUE_APP_BASE_MESSAGE_CHANGE_PASSWORD_REQUIRED_MESSAGE_6;
    },
  },
  mounted() {
    //cookiesからパスワードを取得
    if (this.$cookies.isKey("password")) {

      //存在する場合、パスワードを埋め込み、入力欄を隠す
      this.currentPassword = this.$cookies.get("password");

      this.divCurrentPasswordVisible = false
    } else {

      //存在しない場合、パスワードの入力欄を隠さない
      this.divCurrentPasswordVisible = true

      this.currentPasswordButton = {
        icon: 'key',
        type: 'default',
        onClick: () => {
          this.currentPasswordMode = this.currentPasswordMode === 'text' ? 'password' : 'text';
        }
      }
    }
  },
  methods: {
    onChangePasswordClick(e) {

      if (!e.validationGroup.validate().isValid) return;

      if (this.newPassword != this.confirmPassword) {

        //新パスワードは確認パスワードと相違の場合、メッセージを出して、returnする
        this.showMessage(process.env.VUE_APP_BASE_MESSAGE_CHANGE_PASSWORD_NOSAME, 'error');

        return
      }

      let self = this

      authService.changePassword(
        this.currentPassword
        , this.newPassword)
        .then(
          success => {
            if (success.messageType == 1) {

              var _newPassword = this.newPassword

              self.showMessage(success.message, 'success');

              if (self.$cookies.isKey("rememberUser") && (Boolean)(self.$cookies.get("rememberUser"))) {
                self.$cookies.set('password', _newPassword, process.env.VUE_APP_COOKIES_LIFETIME);
              }

              e.validationGroup.reset();

              this.currentPassword = _newPassword

            } else {
              self.showMessage(success.message, 'error');
            }
          },
          error => {
            console.log(error)
          }
        );
    },
    showMessage(text, type) {
      notify({
        message: text,
        shading: true
      }, type, process.env.VUE_APP_BASE_MESSAGE_NOTIFY_SHOWTIME)
    },
  },
  components: {
    DxButton,
    DxCheckBox,
    DxTextBox,
    DxTextBoxButton,
    DxValidator,
    DxRequiredRule,
    DxValidationGroup
  }
}